import ProgressDot from '../../atoms/ProgressDot';
import {
  ProgressDotWrapper,
  ProgressTrackerContainer,
} from './ProgressTracker.styled';

interface ProgressTrackerProps {
  //total steps in tracker
  steps: number;
  //active step number, 0 based
  activeStep: number;
}

const ProgressTracker = (props: ProgressTrackerProps) => {
  return (
    <ProgressTrackerContainer>
      {Array.from(Array(props.steps).keys()).map((n) => (
        <ProgressDotWrapper key={n} data-testid='progress-dot'>
          <ProgressDot isActive={props.activeStep === n} />
        </ProgressDotWrapper>
      ))}
    </ProgressTrackerContainer>
  );
};

export default ProgressTracker;
